import * as z from "zod";

export const sendMagicLink = {
  name: "sendMagicLink" as const,
  input: z.object({ email: z.email().max(320) }),
  output: z.object({ ok: z.literal(true) }),
};
